<div class="col-12">
    <div class="risk">
        <div class="risk__header">
            <div class="row">
                <div class="col-12">
                    <h2>RISK SCORE</h2>
                    <h1>MODERATELY CONSERVATIVE</h1>
                    <h1>2/5</h1>
                </div>
            </div>
        </div>
        <div class="risk__body">
            <div class="box__cont risk__image">  
            </div>
            <div class="risk__body--para">
                <p>You value reducing risk and enhancing returns equally. Moderate investors are willing to accept modest risks to seek higher normal returns. Investors like these may endure a short-term loss of principal and lower degree of liquidity in exchange for long-term appreciation</p>
                <p>You may be willing to accept moderate investment risk for growth opportunities. Funds like the ATRAM Corporate Bond Fund and ATRAM Philippine Balanced Fund may be appropriate for your investor profile.</p>
            </div>
            <div class="text-center">
                <atram-button label="Continue"
                                componentClass="btn-submit"
                                (on-click)="goToConfirm()">
                </atram-button>
            </div>
        </div>
    </div>
</div>